export const topbar = {
  clientNone: "No tenant",
  clientSelect: "Select tenant",
  partnerNone: "No partner",
  partnerSelect: "Select partner",
  projectNone: "No project",
  projectSelect: "Select project",
  welcome: "Welcome"
};
